import { useEffect, useState } from "react";

export default function useIsTablet(windowBreakpoint = 900) {
  /* A hook for isMobile bool which determines if we should switch to mobile-specific layouts

  Usage:
    const isMobile = useIsMobile();

  Args:
    windowBreakpoint: width in pixels of the window to enable isMobile
   */
  // Always start false so SSR and the first client paint match, then measure after mount.
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const update = () => setIsTablet(window.innerWidth < windowBreakpoint);
    update();
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("resize", update);
    };
  }, [windowBreakpoint]);

  return isTablet;
}
